<template>
    <q-list no-border class="menu-list">
        <q-list-header class="q-pr-lg text-center q-my-xs menu-header">
            <router-link to="/"><img src="../../img/identity/logo-basket.png" width="90%"/></router-link>
        </q-list-header>

        <q-item  link item exact class="big" :to="{name: 'home'}">
            Home
        </q-item>
      <q-item v-for="menu in menus" :key="menu.name"
              link item exact class="big" :to="menu.slug" style="padding-top: 0;padding-bottom: 0;">
        <q-btn style="font-size: 20px; color: #3a3a3a; padding-left: 0; text-transform: none; padding-right: 30%"
               @click.prevent="checkAlerts(menu.slug)">
          <strong>{{ $T(menu.name) }}</strong>
        </q-btn>
      </q-item>

        <q-item-separator/>

        <q-item item>
            <div class="row full-width items-baseline">
                <div class="col">
                    <q-input v-model="query" :placeholder="$T('search')"
                    @keydown.enter.prevent="search"/>
                </div>
                <div class="col-auto">
                    <q-btn icon="search" color="primary" class="super-hover on-right"
                           @click.prevent="search"></q-btn>
                </div>
            </div>
        </q-item>

        <q-item-separator/>
        <!--
        Esses dois primeiros ai embaixo deveriam ser dinâmicos tb. Um "submenu"
        O "minha conta" deve verificar se já está logado v-if.
        Assim como o login/esqueci a senha, logout
        -->
        <q-item link :to="{name: 'contests'}" v-if="total > 0">{{ $T('passatempos') }}</q-item>
        <q-item link :to="{name: 'contact-us'}">{{ $T('contact us') }}</q-item>
        <q-item link :to="{name: 'tec'}">{{ $T('terms ans conditions') }}</q-item>
        <q-item link to="/profile">{{ $T('my account') }}</q-item>

        <q-item-separator/>
        <q-item>
            <div class="col" v-if="user">
                <h6 class="q-mt-none q-mb-xs">{{ $T('welcome to portal basket!') }}</h6>
                {{ $T('close your session') }}
                <q-btn color="primary" class="full-width super-hover q-my-md"
                       :label="$T('log out')" link @click.native="logout"></q-btn>
            </div>

            <div class="col" v-else>
                <h6 class="q-mt-none q-mb-xs">{{ $T('welcome to portal basket!') }}</h6>
                {{ $T('start your session') }}
                <q-btn color="primary" class="full-width super-hover q-my-md" :disable="isDiscontinuedActive"
                       :label="$T('log in')" @click.prevent="$login()"></q-btn>
            </div>

        </q-item>
    </q-list>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {loadMessages} from '../plugins/i18n'
    import {
        QList,
        QListHeader,
        QItem,
        QItemSeparator,
        QBtn,
        QField,
        QInput,
        Cookies
    } from 'quasar-framework'
    import axios from "axios";

    export default {
        components: {
            QList,
            QListHeader,
            QItem,
            QItemSeparator,
            QBtn,
            QField,
            QInput
        },

        computed: {
            ...mapGetters({
                user: 'auth/user',
                locale: 'lang/locale',
                locales: 'lang/locales',
            }),

            /* menus() {
                return window.config.menus
            } */
            isDiscontinuedActive () {
                const hoje = new Date(window.config.serverTime)
                const dataLimite = new Date(window.config.dataLimite)
                return hoje >= dataLimite
            }
        },

        data() {
            return {
                query: '',
                menus: [],
                total: 0,
            }
        },

        mounted() {
          this.getMenus()
        },

        methods: {
            async getMenus() {
                this.menus = []
                if (!Cookies.get('locale') || Cookies.get('locale') === undefined)
                Cookies.set('locale', 'pt', {expires: 1, path: '/'})
                this.portal_base = Cookies.get('portal')
                if (!this.portal_base) {
                    axios.get(`${config.PortalBase}/get-portals`)
                        .then((response) => {
                            if (response.data.length > 0) {
                                this.portal_base = response.data[0].portal.id
                                Cookies.set('portal', this.portal_base, {expires: 1, path: '/'})
                            }
                        }).finally(async () => {
                            await this.getContentMenu()
                    })
                } else {
                await this.getContentMenu()
                }
            },
            async getContentMenu() {
                this.redirect = '/' + this.$route.path.split('/').join('*')
                const {data} = await axios.get(`${config.appUrl}/${this.portal_base}/${null}/leagues?lang=${Cookies.get('locale')}`)
                this.menus.push({"name": "internacional", "slug": "/desporto/by/dsg", "icon": "/img/tab-icon-news.svg" })
                
                if (data['alert'])
                    this.menus.push({"name": data['alert'].name, "slug": data['alert'].slug, "icon": data['alert'].image_path })

                this.menus.push(
                    {"name": "angola", "slug": "/desporto/by/mml", "icon": "/img/tab-icon-local-news.svg" }
                )
                for (const item in data['leagues']) {
                    this.menus.push(data['leagues'][item]);
                }
                axios.get(`${config.appUrl}/${this.portal_base}/${null}/passatempos?lang=${this.locale}`)
                  .then(response => this.total = response.data.content.page.total)
            },
            checkAlerts(slug) {
              if (slug === '/alertas') {
                window.location.href = slug
              } else {
                this.$router.push(slug)
              }
            },
            async logout() {
                // Log out the user.
                this.$router.push("/desporto")

                await this.$store.dispatch('auth/logout')
                window.location.href = '/logout'

                // Redirect to login.
            },

            setLocale(locale) {
                if (this.$i18n.locale !== locale) {
                    loadMessages(locale)

                    this.$store.dispatch('lang/setLocale', {locale})
                }
            },

            search() {
                this.$router.push({ name: 'sports.search', params: {query: this.query} })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Menu.vue